<template>
  <div>
    <main-template-sidebar/>

    <div class="main-content">
      <main-template-topbar/>

      <router-view  />
    </div>
    <portal-target name="modals"/>
  </div>
</template>

<script>
import $ from 'jquery'
import MainTemplateSidebar from './MainTemplateSidebar'
import MainTemplateTopbar from './MainTemplateTopbar'

export default {
  components: {
    MainTemplateSidebar,
    MainTemplateTopbar
  },

  mounted () {
    $('body').attr('class', '')

    $('body').tooltip({
      selector: '[data-toggle="tooltip"]'
    })

    $('body').popover({
      selector: '[data-toggle="popover"]',
      trigger: 'focus'
    })
  }
}
</script>
